export function parseCookies(): Record<string, string> {
  return Object.fromEntries(
    document.cookie.split(";").map((pair) => {
      const cookie = pair.split("=");
      return [cookie[0]?.trim(), cookie[1]] as const;
    }),
  );
}

export async function detectCookiesEnabled() {
  if (!navigator.cookieEnabled) return false;

  // Try CookieStore API
  if ("cookieStore" in window) {
    try {
      const cookies = await window["cookieStore"].getAll();
      if (cookies.length === 0) return false;
    } catch {
      return false;
    }
  }

  // Try test cookie
  document.cookie = "test_cookie=1; SameSite=Lax; path=/";
  if (!document.cookie.includes("test_cookie")) return false;

  return true;
}
(window as any).detectCookiesEnabled = detectCookiesEnabled;

export function callWithTimeout(
  invoke: (callback: (value?: string) => void) => void,
  timeout = 5000,
): Promise<string | undefined> {
  return Promise.race([
    new Promise<string | undefined>((resolve) => {
      invoke((value) => {
        resolve(value?.toString());
      });
    }),
    new Promise<undefined>((_, reject) =>
      setTimeout(
        () => reject(new Error("Analytics cookie parsing timeout")),
        timeout,
      ),
    ),
  ]);
}
